import { Button, ButtonProps, Icon } from "@blueprintjs/core"
import { useToggle } from "@mantine/hooks"
import CustomButton, { CustomButtonProps } from "components/Atoms/CustomButton"
import CustomPopover from "components/Atoms/CustomPopover"
import React from "react"

type ConfirmButtonType = CustomButtonProps & {
  title: React.ReactNode
  subtitle?: React.ReactNode
  confirmButtonProps?: ButtonProps
  cancelButtonProps?: ButtonProps
  onOpened?: () => void
}
const ConfirmButton = ({
  title,
  subtitle,
  confirmButtonProps,
  cancelButtonProps,
  onOpened,
  ...props
}: ConfirmButtonType) => {
  const [isOpen, setIsOpen] = useToggle()
  return (
    <CustomPopover
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onOpened={onOpened}
      content={
        <div className="text-sm p-2 max-w-sm">
          <p className="mb-1 text-gray-800">
            <Icon intent="warning" icon="warning-sign" /> {title}
          </p>
          {subtitle && <p className=" text-gray-700">{subtitle}</p>}
          <footer className="flex justify-end mt-3">
            <Button
              className="mr-2"
              small
              text={"Cancel"}
              onClick={e => {
                setIsOpen(false)
                cancelButtonProps?.onClick?.(e)
              }}
              {...cancelButtonProps}
            />
            <Button
              small
              intent="primary"
              text={"Confirm"}
              {...confirmButtonProps}
            />
          </footer>
        </div>
      }
    >
      <CustomButton
        intent="success"
        onClick={() => setIsOpen()}
        text={"Save"}
        {...props}
      />
    </CustomPopover>
  )
}

export default ConfirmButton
